module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "awc-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "awc-toolbar"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "awc-toolbar-actions"
  }, [_c('runner-field-visibility-control', {
    attrs: {
      "modal-name": "completedRunnersFieldVisibility",
      "title": "Completion Fields",
      "subtitle": "Choose the runner fields shown on this page",
      "field-options": _vm.fieldOptions,
      "selected-fields": _vm.selectedFieldIds
    },
    on: {
      "apply": _vm.applyFieldSelection,
      "reset": _vm.resetFieldSelection
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "awc-count-pill"
  }, [_vm._v(_vm._s(_vm.runners.length) + " runners on this page")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "awc-list"
  }, _vm._l((6), function(n) {
    return _c('div', {
      key: 'awc-skeleton-' + n,
      staticClass: "awc-card awc-card--skeleton"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "awc-field-grid"
    }, _vm._l((10), function(field) {
      return _c('div', {
        key: 'awc-field-' + n + '-' + field,
        staticClass: "awc-skeleton-field sk-shimmer"
      })
    }), 0)])
  }), 0) : (_vm.runners.length === 0) ? _c('div', {
    staticClass: "awc-empty"
  }, [_c('span', {
    staticClass: "awc-empty-icon"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 7v5l3 2"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "awc-empty-title"
  }, [_vm._v("No completed-run records")]), _vm._v(" "), _c('p', {
    staticClass: "awc-empty-text"
  }, [_vm._v("Runner completion data will appear here once it is available.")])]) : _c('div', {
    staticClass: "awc-list"
  }, _vm._l((_vm.runners), function(runner, index) {
    return _c('article', {
      key: runner.id || index,
      staticClass: "awc-card"
    }, [_c('div', {
      staticClass: "awc-card-header"
    }, [_c('span', {
      staticClass: "awc-card-icon"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "12",
        "cy": "8",
        "r": "4"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M4 21a8 8 0 0 1 16 0"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "awc-runner-title"
    }, [_c('h2', {
      staticClass: "awc-runner-name"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.runnerName, 'Unnamed runner')))]), _vm._v(" "), _c('div', {
      staticClass: "awc-runner-meta"
    }, [_c('button', {
      staticClass: "awc-id-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getRunnersData(runner.id)
        }
      }
    }, [_vm._v("ID " + _vm._s(_vm.displayValue(runner.id)))]), _vm._v(" "), _vm._l((_vm.runnerMetaFields(runner)), function(meta) {
      return [_c('span', {
        key: meta.id + '-dot',
        staticClass: "awc-meta-dot"
      }), _vm._v(" "), _c('span', {
        key: meta.id
      }, [_vm._v(_vm._s(meta.value))])]
    })], 2)]), _vm._v(" "), (_vm.isRunnerFieldVisible('days-since-last')) ? _c('div', {
      staticClass: "awc-recency"
    }, [_c('span', {
      staticClass: "awc-recency-label"
    }, [_vm._v("Days since last")]), _vm._v(" "), _c('span', {
      staticClass: "awc-recency-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.daysSinceLastClass, '0')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "awc-field-grid"
    }, [(_vm.isRunnerFieldVisible('email')) ? _c('div', {
      staticClass: "awc-field awc-field--wide"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value awc-value--break"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.email)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('account-create')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Account create")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.accountCreate)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('facebook')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Facebook")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(runner.facebook ? 'Yes' : 'No'))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('trial-start')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Trial start")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.membershipStartDate)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('trial-end')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Trial end")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.membershipEndDate)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('completed-runs')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Completed runs")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.totalCompletedRuns, '0')))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('last-liverun')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Last LiveRun")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.lastLiveRun)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('height')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Height")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.height)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('weight')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Weight")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.weight)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('promo-code')) ? _c('div', {
      staticClass: "awc-field"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Promo code")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.promoCode)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('website')) ? _c('div', {
      staticClass: "awc-field awc-field--wide"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Website")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value awc-value--break"
    }, [_vm._v(_vm._s(_vm.displayValue(runner.website)))])]) : _vm._e(), _vm._v(" "), (_vm.isRunnerFieldVisible('profile-text')) ? _c('div', {
      staticClass: "awc-field awc-field--full"
    }, [_c('span', {
      staticClass: "awc-label"
    }, [_vm._v("Profile text")]), _vm._v(" "), _c('span', {
      staticClass: "awc-value awc-value--multiline"
    }, [_vm._v(_vm._s(_vm.runnerProfileText(runner)))])]) : _vm._e()])])
  }), 0), _vm._v(" "), (!_vm.loading && _vm.totalPages > 0) ? _c('div', {
    staticClass: "awc-pagination-footer"
  }, [_c('div', {
    staticClass: "awc-pagination-summary"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('paginate', {
    attrs: {
      "page-count": _vm.totalPages,
      "click-handler": _vm.handlePaginate,
      "prev-text": 'Prev',
      "next-text": 'Next',
      "container-class": 'awc-pagination',
      "page-class": 'awc-pagination-item',
      "page-link-class": 'awc-pagination-link',
      "prev-class": 'awc-pagination-item',
      "prev-link-class": 'awc-pagination-link',
      "next-class": 'awc-pagination-item',
      "next-link-class": 'awc-pagination-link',
      "active-class": 'awc-pagination-active',
      "disabled-class": 'awc-pagination-disabled'
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Days Since Last LiveRun")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Review runner completion history and recency signals")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "awc-toolbar-title"
  }, [_vm._v("Completion recency")]), _vm._v(" "), _c('p', {
    staticClass: "awc-toolbar-subtitle"
  }, [_vm._v("Sorted runner profiles with last LiveRun and completed run totals.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "awc-card-header"
  }, [_c('div', {
    staticClass: "awc-skeleton-icon sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "awc-skeleton-heading"
  }, [_c('div', {
    staticClass: "awc-skeleton-title sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "awc-skeleton-subtitle sk-shimmer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed0d62e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AllWithRunCompleted.vue
// module id = 1677
// module chunks = 2